export const shouldShowGrid = (user) => {
    if (!user)
        return false;
    if (user.qtsPlacementType === 'Secondment') {
        return true;
    }
    const optionalProps = [
        user.companyName,
        user.address,
        user.zipCode,
        user.countryId,
        user.companyName,
        user.status,
        user.kvk,
        user.position,
        user.vat,
        user.bankAccountNumber,
        user.bankAccountTitle,
        user.companyAddress,
        user.companyCountry,
        user.companyZipCode
    ];
    return optionalProps.every((prop) => prop != null);
};
